import getLang from '../i18n/getLang'
const lang = getLang()

export default window.location.origin + (lang === 'en' ? '' : (lang === 'nl' ? '/nl' : `/cn`))


// WEBPACK FOOTER //
// ./resources/js/lib/axios/base_url.js